export const marketing = [
  {
    path: '/m/:alias1',
    isEmbed: false,
    options: false,
  },
  {
    path: '/m/:alias1/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/m/:alias1/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/m/:alias1/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/m/:alias1/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/m/:alias1/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/m/:alias1/:alias2',
    isEmbed: false,
    options: false,
  },
  {
    path: '/m/:alias1/:alias2/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/m/:alias1/:alias2/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/m/:alias1/:alias2/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/m/:alias1/:alias2/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/m/:alias1/:alias2/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/marketing/:alias1',
    isEmbed: false,
    options: false,
  },
  {
    path: '/marketing/:alias1/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/marketing/:alias1/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/marketing/:alias1/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/marketing/:alias1/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/marketing/:alias1/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/marketing/:alias1/:alias2',
    isEmbed: false,
    options: false,
  },
  {
    path: '/marketing/:alias1/:alias2/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/marketing/:alias1/:alias2/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/marketing/:alias1/:alias2/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/marketing/:alias1/:alias2/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/marketing/:alias1/:alias2/embed/options',
    isEmbed: true,
    options: true,
  },
];
